import API from "../client";

const state = {
  data: [],
  config: [],
};

const mutations = {
  UPDATE_DATA(state, data) {
    state.data = data;
  },
  UPDATE_CONFIG(state, config) {
    config.sort(function(a, b) {
      return a.id - b.id;
    });
    state.config = config;
  },
  UPDATE_CONFIG_DATA(state, { key, param, value }) {
    let index = state.config.findIndex((c) => c.key === key);

    if (index > -1) {
      state.config[index][param] = value;
    }
  },
  UPDATE_CONFIG_DATA_BY_NAME(state, { name, param, value }) {
    let index = state.config.findIndex((c) => c.name === name);

    if (index > -1) {
      state.config[index][param] = value;
    }
  },
  CLEAR_STATE(state) {
    state.data = [];
    state.config = [];
  },
};

const actions = {
  fetch({ commit }, measureId) {
    API.get("/measures/" + measureId + "/series").then(({ data }) => {
      commit("UPDATE_DATA", data.series);
      commit("UPDATE_CONFIG", data.config);
    });
  },
  updateConfigData({ commit }, [key, param, value]) {
    commit("UPDATE_CONFIG_DATA", { key, param, value });
  },
  updateConfigDataByName({ commit }, [name, param, value]) {
    commit("UPDATE_CONFIG_DATA_BY_NAME", { name, param, value });
  },
  updateConfig({ commit }, { measureId, config }) {
    const updateParams = config.map((c) => {
      let result = {};
      ["id", "name", "coeff", "offset", "visible"].forEach(
        (key) => (result[key] = c[key])
      );

      return result;
    });

    API.patch("/measures/" + measureId + "/graph_configs", {
      measure: { graph_configs_attributes: updateParams },
    }).then(({ data }) => {
      commit("UPDATE_CONFIG", data);
    });
  },
  clear({ commit }) {
    commit("CLEAR_STATE");
  },
};

const getters = {
  data: (state, getters) => {
    let result = [];

    if (state.data.length === 0) return result;

    state.config
      .filter((c) => c.visible)
      .map((c) => {
        result.push({
          x: getters.getDatasetByKey("time"),
          y: getters.generateDataset(c.key),
          yaxis: c.yaxis,
          mode: c.mode,
          name: c.name,
          line: { dash: c.line },
          type: "scatter",
        });
      });

    return result;
  },
  generateDataset: (state, getters) => (key) => {
    let config = getters.getConfigByKey(key);
    return state.data[0].values.map((v) =>
      round(v[key] / config.coeff - config.offset, 2)
    );
  },
  getDatasetByKey: (state) => (key) => {
    return state.data[0].values.map((v) => v[key]);
  },
  getConfigByKey: (state) => (key) => {
    return state.config.find((c) => c.key === key);
  },
};

function round(number, precision) {
  var shift = function(number, precision, reverseShift) {
    if (reverseShift) {
      precision = -precision;
    }
    var numArray = ("" + number).split("e");
    return +(
      numArray[0] +
      "e" +
      (numArray[1] ? +numArray[1] + precision : precision)
    );
  };
  return shift(Math.round(shift(number, precision, false)), precision, true);
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
